// extracted by mini-css-extract-plugin
module.exports = {"signUp":"index--signUp--3jLp1","signUp__row":"index--signUp__row--19FQh","button__icon":"index--button__icon--2H84F","signIn__buttons":"index--signIn__buttons--1pYnE"};